import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ImageOff = createReactComponent("ImageOff", ["svg", defaultAttributes, [["path", {
  d: "M2 2l20 20",
  key: "131xdx"
}], ["path", {
  d: "M9 3h10a2 2 0 012 2v10M3.59 3.59A2 2 0 003 5v14c0 1.1.9 2 2 2h14a2 2 0 001.41-.59",
  key: "191sqh"
}], ["path", {
  d: "M9.56 9.56a1.5 1.5 0 01-2.12-2.12",
  key: "11hmqw"
}], ["path", {
  d: "M21 15l-5-5M5 21l8-8",
  key: "1xyrbb"
}]]]);
export default ImageOff;